<div class="mat-card card">
  <div class="row">
    <div class="col-8">
      <h2 class="main-heading">
        Manage Prescription Templates
      </h2> 
    </div>  
    <div class="col-4">
      <button mat-button class="submit" (click)="addPrescription()">Add New Template</button>
    </div>
  </div>

  <!-- Filter Section -->
  <div class="mb-4 flex items-center">
    <div class="w-64 mr-4">
      <select 
        [(ngModel)]="selectedDepartment" 
        (change)="onDepartmentChange()"
        class="w-full p-2 border border-gray-300 rounded focus:ring-blue-500 focus:border-blue-500">
        <option value="" disabled>Select Department</option>
        <option *ngFor="let dept of departments" [value]="dept._id">
          {{ dept.name }}
        </option>
      </select>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="p-4 text-center text-gray-500">
    Loading data...
  </div>

  <div class="matTableDiv">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      <ng-container matColumnDef="treatment">
        <th mat-header-cell *matHeaderCellDef> Treatment </th>
        <td mat-cell *matCellDef="let element" id="treatment">
          {{element.treatment || 'NA'}}
        </td>
      </ng-container>

      <ng-container matColumnDef="prescribed_drugs">
        <th mat-header-cell *matHeaderCellDef> Prescribed Drugs </th>
        <td mat-cell *matCellDef="let element" id="prescribed_drugs">
          <span *ngIf="element.prescribed_drugs?.length" class="StatusBlue">
            {{ element.prescribed_drugs.length }} drugs
          </span>
          <span *ngIf="!element.prescribed_drugs?.length">NA</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef> Created On </th>
        <td mat-cell *matCellDef="let element" id="createdAt">
          {{element.createdAt | date:'shortDate' || 'NA'}}
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef> Status </th>
        <td mat-cell *matCellDef="let element" id="status">
          <span class="StatusGreen">Active</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef> Action </th>
        <td mat-cell *matCellDef="let element">
          <span class="material-icons editDelete" (click)="editPrescription(element._id)" title="Edit">edit</span>
          <span class="material-icons editDelete" (click)="deletePrescription(element._id)" title="Delete">delete</span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr class="data" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

  <!-- Empty State -->
  <div *ngIf="!isLoading && dataSource.length === 0" class="text-center py-12 text-gray-500">
    No prescription templates found.
  </div>
</div>